import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { createButtonCreate } from "../../../../utils/button";
import { onClickDeleteAllClient } from '../../../../utils/form';
import { createLoading } from '../../../../utils/loading';
import { has } from "../../../../utils/menu-context";
import { createManageDelete, createPage } from '../../../../utils/page';
import lodash from 'lodash'
import { openModalList } from "../../master-mgt/coordinate-customs/coordinate-customs.logic";
import { onIFrameClickSelectAll } from "../../../../utils/iframe";
import { callSubStanceTypeByGroup, callUnitByGroup } from "../coordinate-customs/coordinate-customs.section";

export const { isLoading, setIsLoading } = createLoading()

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.coordinateCustoms.name"), dataIndex: "refCoordinateCustoms.name",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.coordinateCustoms.code"), dataIndex: "refCoordinateCustoms.code",  align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.coordinateCustoms.refDetailSubStanceType"),
            dataIndex: "refCoordinateCustoms.refDetailSubStanceType.id",
            customRender: ({ record }) => <div>{record.refCoordinateCustoms?.refDetailSubStanceType?.value}</div>,
            inputProp: () => ({ list: callSubStanceTypeByGroup, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.coordinateCustoms.refUnit"),
            dataIndex: "refCoordinateCustoms.refUnit.id",
            customRender: ({ record }) => <div>{record.refCoordinateCustoms?.refUnit?.value}</div>,
            inputProp: () => ({ list: callUnitByGroup, optLabel: "value" }),
            align: "center"
        }),
    ]
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visible } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
    ]
    data.manageExtras = []
    data.rowActions = []
    if (!viewOnly) {
        if (visible) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalList({
                            onIframeMounted: ({ refs, options }) => {
                                onIFrameClickSelectAll({
                                    refs, options, items, itemKey: 'refCoordinateCustoms.id', rowKey: 'id', setKey: 'refCoordinateCustoms',
                                })
                            },
                        }),
                        options: { text: i18n.global.t('model.coordinateCustoms.modelName') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
        }
    }
}